var BrowserFS = require('browserfs');module.exports=BrowserFS.BFSRequire('buffer');



/*****************
 ** WEBPACK FOOTER
 ** ./shims/buffer.js
 ** module id = 29
 ** module chunks = 0
 **/